import { Core } from "@faire/design-tokens";
import styled, { css } from "styled-components";
/**
 * @trackcomponent
 * @supersededBy "@faire/web/slate/ProgressBar/ProgressBar#ProgressBar"
 */ export var BareProgressBar = styled.div.withConfig({
    componentId: "sc-fd89ba1c-0"
})([
    "position:relative;border-radius:3px;background-color:",
    ";height:",
    ';flex:1;&::before{content:"";position:absolute;top:0;left:0;border-radius:3px;background-color:',
    ";height:100%;",
    ";}"
], function(param) {
    var backgroundColor = param.$backgroundColor;
    return backgroundColor !== null && backgroundColor !== void 0 ? backgroundColor : Core.surface.subdued;
}, function(param) {
    var height = param.$height;
    return height !== null && height !== void 0 ? height : "6px";
}, function(param) {
    var color = param.$color;
    return color !== null && color !== void 0 ? color : Core.surface.default;
}, function(param) {
    var smooth = param.$smooth, progress = param.$progress;
    return smooth ? css([
        "width:",
        "%;transition:width 0.4s cubic-bezier(0.7,-0.4,0.4,1.4);"
    ], progress) : css([
        "width:",
        "%;"
    ], progress);
});
